import { CSS, StyleProps } from "@shared/primitive-components"

export const card = (props: StyleProps): CSS => ({
  flexDirection: `column`,
  gap: props.theme.spacing(4),
  marginBottom: props.theme.spacing(4),
})

export const header = (props: StyleProps): CSS => ({
  display: `flex`,
  alignItems: `center`,
  gap: props.theme.spacing(2),
})

export const title = (): CSS => ({
  marginBottom: 0,
})

export const form = (props: StyleProps): CSS => ({
  display: `flex`,
  alignItems: `center`,
  gap: props.theme.spacing(2),
})

export const inputWrap = (): CSS => ({
  flexGrow: 1,
  minWidth: 0,
})

export const submit = (): CSS => ({
  flexShrink: 0,
})

export const suggestions = (props: StyleProps): CSS => ({
  display: `flex`,
  flexWrap: `wrap`,
  gap: props.theme.spacing(2),
})

// Matches the follow-up chips under Jay's answers in the portal (FollowUpChips): a light pill
// whose border turns brand yellow with a matching ring on hover or keyboard focus.
export const suggestion = (props: StyleProps): CSS => ({
  ...props.theme.fonts.body,
  display: `inline-flex`,
  alignItems: `center`,
  // Jay's follow-up chips' height, and a comfortable touch target; the spacing scale has no 44.
  minHeight: `44px`,
  padding: props.theme.spacing(0, 4),
  border: `1px solid ${props.theme.palette.grey.light}`,
  borderRadius: props.theme.borderRadius.pill,
  backgroundColor: props.theme.palette.white,
  color: props.theme.palette.coal.dark,
  fontSize: props.theme.fontSize.caption,
  textAlign: `left`,
  cursor: `pointer`,
  transition: `border-color 0.15s ease, box-shadow 0.15s ease`,
  "&:hover, &:focus-visible": {
    outline: `none`,
    borderColor: props.theme.palette.brand,
    boxShadow: `0 0 0 1px ${props.theme.palette.brand}`,
  },
})
